import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import ToshipList from './ToshipList'

export default {
    list: ToshipList,
    icon: PeopleOutlineIcon,
};
